import saveToBraze from "src/utils/brazeUploader";
import { SessionStorageKey } from "src/utils/constants";
import { getNoomSessionStorage } from "src/utils/noomSessionStorage";
import { isMHMDAState } from "src/utils/userSegment/features";

/**
 * Writes the MHMDA marketing consent captured on an email page to Braze. Run it
 * only after the survey answers, and so the email, are saved.
 */
export async function saveMhmdaConsent(): Promise<void> {
  if (!isMHMDAState()) return;

  const mhmdaAnswer = getNoomSessionStorage(SessionStorageKey.mhmdaAnswer);
  if (mhmdaAnswer === true || mhmdaAnswer === false) {
    await saveToBraze({ user: { mhmdaOptIn: mhmdaAnswer } });
  }
}
